module.exports = __webpack_public_path__ + "img/Weapon_66.cd61c6e4.png";